import React, { useEffect, useRef, useState } from "react";
import iconPhao from "../../../../assets/images/Event-2025/Asset 4@4x (1).png";
import iconDiem from "../../../../assets/images/Event-2025/icon-diem-event.png";
import bgBox from "../../../../assets/images/Event-2025/Frame 6.png";
import bg from "../../../../assets/images/Event-2025/bg-firework.png";
import titleFileWorks from "../../../../assets/images/Event-2025/Group 84.png";
import layer01 from "../../../../assets/images/Event-2025/Layer_1.png";
import iconYourCollect from "../../../../assets/images/Event-2025/bg-collect-tion.png";
import bgBtn from "../../../../assets/images/Event-2025/bg-btn.png";
import iconPhaoCollect from "../../../../assets/images/Event-2025/Group 118.png";
import { useLocation, useHistory } from "react-router-dom";
import TextGradient from "../components/TextGradient";
import layer2 from "../../../../assets/images/Event-2025/Layer_2.png";
import iconFooterBottom from "../../../../assets/images/Event-2025/icon-footer-bottom.png";
import iconSnow from "../../../../assets/images/Event-2025/icon-snow.png";
import iconTree from "../../../../assets/images/Event-2025/icon-tree.png";
import test from "../../../../assets/images/Event-2025/Group 84 (1).png";
import iconLightUp from "../../../../assets/images/Event-2025/Frame 14.png";
import iconSpecCode from "../../../../assets/images/Event-2025/spec-code.png";
import iconChrisTree from "../../../../assets/images/Event-2025/chris-tree.png";
import "./index.scss";
import PopupComponentError from "../components/Popup/PopupComponentError";
import iconErrorDiem from "../../../../assets/images/Event-2025/icon-error-diem.png";
import iconErrorPhao from "../../../../assets/images/Event-2025/Asset 4@4x (2).png";
import iconError2 from "../../../../assets/images/Event-2025/Group 120 1.png";
import iconNg from "../../../../assets/images/Event-2025/Frame 124.png";
import iconTh from "../../../../assets/images/Event-2025/image 91.png";
import iconNgSuccess from "../../../../assets/images/Event-2025/image 92.png";
import iconSuperBox from "../../../../assets/images/Event-2025/Frame 55 1.png";
import iconFileWordSuccess from "../../../../assets/images/Event-2025/Group 108.png";
import Firework from "../components/Firework/firework";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
//new
import { getCheckStatusEvent, getStatisticEvent } from "dataLayer/product";
import { usePairingEventNewYear } from "dataLayer/user";
import { PATHS } from "@config/constants";
import { ID_TAB_EVENT_NEW_YEAR } from "@config/constants/helper";
import { isLoggedIn } from "@utils/cookie";
// import { usePairingEventNewYear } from "dataLayer/user";

export default function GameFileWorks({ setOpenModalLogin }) {
  const { t } = useTranslation();
  // const statisticFirework = null;
  // const statusEvent = {
  //     "is_show": 1
  // }
  const isLoadingPairing = useRef(false);
  const [isClickedFirework, setIsClickedFirework] = useState(false);
  const [isZoomSpec, setIsZoomSpec] = useState(false);
  const [isZoomTree, setIsZoomTree] = useState(false);
  const [typeOpenGift, setTypeOpenGift] = useState(false);
  const dataPopup = useRef({
    imgMain: "",
    imgLeft: "",
    imgRight: "",
    contentHeader: "",
    descriptionHeader: "",
    descriptionFooter: "",
    contentAction: "",
    isFailsAll: false,
    action: () => {},
  });
  const [open, setOpen] = useState(false);
  // new
  const history = useHistory();
  const { data: statisticFirework = {}, refetch } = useQuery(
    getStatisticEvent()
  );
  const { data: statusEvent, refetch: refetchStatus } = useQuery(
    getCheckStatusEvent()
  );
  const {
    mutate: mutateWork,
    data,
    isSuccess,
    error,
    isLoading,
  } = usePairingEventNewYear();

  const handleBuyEquip = (url) => {
    if (PATHS.ACCOUNT_PAGE === url) {
      const isLogin = isLoggedIn();
      if (!isLogin) {
        return history.push(PATHS.LOGIN_PAGE);
      }
      return history.push(url, { isPagePack: true });
    }
    history.push(url);
  };

  useEffect(() => {
    let timerOut;
    setIsZoomSpec(true);
    setIsZoomTree(true);
    timerOut = setTimeout(() => {
      setIsZoomSpec(false);
      setIsZoomTree(false);
    }, 4000);

    return () => clearTimeout(timerOut);
  }, []);

  useEffect(() => {
    let timerOut;
    if (typeOpenGift && !open) {
      setIsZoomTree(true);
      timerOut = setTimeout(() => {
        setIsZoomTree(false);
      }, 4000);
    }
    return () => clearTimeout(timerOut);
  }, [typeOpenGift, open]);

  const handleLightUp = async () => {
    const isLogin = isLoggedIn();
    if (isLoading) {
      return;
    }
    if (!isLogin) {
      return setOpenModalLogin(true);
    }

    if (!statisticFirework.spark && !statisticFirework?.shell) {
      console.log("hết cả 2");
      dataPopup.current = {
        imgMain: iconError2,
        imgLeft: iconNg,
        imgRight: iconTh,
        contentHeader: `${t("event_new_year.oops")}`,
        descriptionHeader: `${t(
          "event_new_year.out_of_both_Matches_and_Firework_Shells"
        )}`,
        descriptionFooter: `${t(
          "event_new_year.each_bid_will_randomly_receive_1_5_matches"
        )} ${t("event_new_year.bigger_packages_give_more_Firework_Shells")}`,
        isFailsAll: true,
        strokeWidth: 3,
      };
      setOpen(true);
      return;
    }

    if (!statisticFirework.spark) {
      console.log("hết diêm");
      dataPopup.current = {
        imgMain: iconErrorDiem,
        imgLeft: iconNg,
        imgRight: iconTh,
        contentHeader: `${t("event_new_year.oops")}`,
        descriptionHeader: `${t(
          "event_new_year.out_of_matches_to_launch_fireworks"
        )}`,
        descriptionFooter: `${t(
          "event_new_year.each_bid_will_randomly_receive_1_5_matches"
        )}`,
        contentAction: `${t("event_new_year.bid_now")}`,
        strokeWidth: 3,
        action: () => handleBuyEquip(PATHS.BID2_PAGE),
        classItem: "error-diem"
      };
      setOpen(true);
      return;
    }

    if (!statisticFirework.shell) {
      console.log("hết vỏ pháo");
      dataPopup.current = {
        imgMain: iconErrorPhao,
        imgLeft: iconNg,
        imgRight: iconTh,
        contentHeader: `${t("event_new_year.oops")}`,
        descriptionHeader: `${t("event_new_year.no_firework_shells_left")}`,
        descriptionFooter: `${t(
          "event_new_year.bigger_packages_give_more_Firework_Shells"
        )}`,
        contentAction: `${t("event_new_year.buy_packages")}`,
        strokeWidth: 3,
        action: () => handleBuyEquip(PATHS.ACCOUNT_PAGE),
      };
      setOpen(true);
      return;
    }
    // success
    mutateWork(
      {},
      {
        onSuccess: (data) => {
          setIsClickedFirework(true);
          setOpen(true);
          if (data?.data?.superBoxNew) {
            const shellPark =
              statisticFirework.spark > statisticFirework.shell
                ? statisticFirework.shell
                : statisticFirework.spark;
            const superBoxNew = data?.data?.superBoxNew;
            dataPopup.current = {
              imgMain: iconSuperBox,
              imgLeft: iconNgSuccess,
              imgRight: iconTh,
              contentHeader: `${t("event_new_year.congrats")}`,
              descriptionHeader: `¡Felicitaciones! ¡Encendiste con éxito ${shellPark} Fuegos artificiales y obtuviste ${superBoxNew} Súper Caja Navideña por 1 objetivo!`,
              descriptionFooter: `${t(
                "event_new_year.reach_firework_milestones_50_100"
              )}`,
              contentAction: `${t("event_new_year.close")}`,
              action: () => setOpen(false),
              classItem: "item-success__event-2025"
            };
            setTypeOpenGift(true);
            //   dispatch(getConfigEventNewYear2024());
          } else {
            const shellPark =
              statisticFirework.spark > statisticFirework.shell
                ? statisticFirework.shell
                : statisticFirework.spark;
            let desHeader = "";
            if (shellPark == 1) {
              desHeader = `¡Felicitaciones! ¡Has encendido con éxito ${shellPark} Fuegos Artificiales, llevando la celebración mágica en esta Navidad Explosiva!`;
            } else {
              desHeader = `¡Felicitaciones! ¡Has encendido con éxito ${shellPark} Fuegos Artificiales, llevando la celebración mágica en esta Navidad Explosiva!`;
            }
            dataPopup.current = {
              imgMain: iconFileWordSuccess,
              imgLeft: iconNgSuccess,
              imgRight: iconTh,
              contentHeader: `${t("event_new_year.congrats")}`,
              descriptionHeader: desHeader,
              descriptionFooter: `${t(
                "event_new_year.reach_firework_milestones_50_100"
              )}`,
              contentAction: `${t("event_new_year.close")}`,
              action: () => setOpen(false),
              classItem: "item-success__event-2025"
            };
          }

          refetch();
          refetchStatus();
          isLoadingPairing.current = false;
        },
      }
    );
  };

  const boxItemDetail = (data) => {
    const { numberTotal, bgLayer, icon, title, btn } = data;
    return (
      <div className="event-2024-body-game">
        <div className="layer-1-container">
          <img src={bgLayer} alt="layer 1" className="layer-1" />
        </div>
        <div className="position-relative event-2024-body-game-item">
          <img src={bgBox} alt="" className="icon-item-event"/>
          <div className="total-diem-event">
            <TextGradient
              title={numberTotal || 0}
              stop={[
                { offset: "0%", color: "#F6EAB8" },
                { offset: "36%", color: "#C9913B" },
                { offset: "65%", color: "#F8F4B4" },
                { offset: "97%", color: "#C9913B" },
              ]}
              fontSize="48"
              height="45"
              width="100%"
              isBold
              isCenterItem
            />
          </div>
          <div className="event-game-icon">
            <img src={icon} alt="icon" className="icon-diem" />
            <div className="event-game-title">{title || ""}</div>
            <div className="event-game-action">
              <div onClick={btn.action} className="action-detail">
                <img src={bgBtn} alt="" className="game-action-btn" />
                <div className="event-game-action-content">
                  {btn.content || ""}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-main-event-2024">
      {isClickedFirework ? (
        <Firework
          openFirework={isClickedFirework}
          setIsClickedFirework={setIsClickedFirework}
        />
      ) : null}
      {open && 
      <PopupComponentError
        open={open}
        setOpen={setOpen}
        data={dataPopup.current}
        isPageNewYear
        wrapClassName={dataPopup.current?.classItem}
      />}
      <div className="container-detail-event-main">
        <img src={bg} alt="" className="event-2024-bg" />
        <div className="body-event-2024">
          <div className="icon-title-file-works">
            <img src={titleFileWorks} alt="" className="title-file-works" />
          </div>
          <div className="icon_spec_chris_tree">
            <div
              className={`chris_tree position-relative ${
                isZoomTree || (typeOpenGift && !open) ? "zoom-in-out" : ""
              }`}
              onClick={() =>
                history.push(
                  `${PATHS.EVENT_2025}/${ID_TAB_EVENT_NEW_YEAR.christmasTree}`
                )
              }
            >
              <span className="num_super num">
                {statusEvent?.open_super_left || 0}
              </span>
              <span className="num_nomal num">
                {statusEvent?.open_left || 0}
              </span>
              <img src={iconChrisTree} alt="" />
            </div>
          </div>
          <div className="event-container-your-collect">
            <img
              src={iconYourCollect}
              alt="icon your collect"
              className="icon-your-collect"
            />
            <div className="icon-phao-collect">
              <img src={iconPhaoCollect} alt="" />
            </div>
            <div className="text-gradient">
              <div>
                <TextGradient
                  title={t("event_new_year.your_collection")}
                  stop={[
                    { offset: "0%", color: "#F6EAB8" },
                    { offset: "36%", color: "#C9913B" },
                    { offset: "65%", color: "#F8F4B4" },
                    { offset: "97%", color: "#C9913B" },
                  ]}
                  fontSize={`${window.innerWidth < 576 ? 13 : 14}`}
                  width="100"
                  isDefaultFont
                />
              </div>
            </div>
            <div className="event-2024-total-collect">
              <TextGradient
                title={statisticFirework?.firework || 0}
                stop={[
                  { offset: "0%", color: "#F6EAB8" },
                  { offset: "36%", color: "#C9913B" },
                  { offset: "65%", color: "#F8F4B4" },
                  { offset: "97%", color: "#C9913B" },
                ]}
                fontSize="22"
                isBold
                isDefaultFont
              />
            </div>
          </div>
          <div className="event-body-detail">
            <div className="diem-container-event">
              {boxItemDetail({
                numberTotal: statisticFirework?.spark || 0,
                bgLayer: layer01,
                icon: iconDiem,
                title: `${t("event_new_year.get_more_matches_here")}`, //"Get more Matches here",
                btn: {
                  content: `${t("event_new_year.bid_now")}`,
                  action: () => {
                    handleBuyEquip(PATHS.BID2_PAGE);
                  },
                },
              })}
            </div>
            <div className="phao-container-event">
              {boxItemDetail({
                numberTotal: statisticFirework?.shell || 0,
                bgLayer: layer2,
                icon: iconPhao,
                title: `${t("event_new_year.get_more_firework_here")}`,
                btn: {
                  content: t("event_new_year.buy_packages"),
                  action: () => {
                    handleBuyEquip(PATHS.ACCOUNT_PAGE);
                  },
                },
              })}
            </div>
          </div>
          <div className="container-btn-lightup">
            <div onClick={handleLightUp} className="container-btn-lightup-btn">
              <img src={iconLightUp} alt="" />
              <div className="btn-lightup-content">
                {t("event_new_year.light_up")}
              </div>
            </div>
            <div className="container-btn-lightup-noti">
              {t("event_new_year.click_to_light_the_fireworks")}
            </div>
          </div>
        </div>
        <div className="event-2024-footer" style={{ pointerEvents: "none" }}>
          <div className="container-icon-footer-bottom child-5">
            <img src={iconFooterBottom} alt="" className="icon-footer" />
          </div>
          <div className="container-icon-footer-bottom-2 child-4">
            <img style={{width: '100%'}} src={test} alt="" />
          </div>
          <div className="container-cion-footer-bottom-3 child-3">
            <img src={iconSnow} alt="snow" className="icon-snow" />
          </div>
          <div className="container-icon-footer-bottom-4 child-3">
            <img src={iconTree} alt="" className="icon-tree-left" />
            <img src={iconTree} alt="" className="icon-tree-right" />
          </div>
        </div>
      </div>
    </div>
  );
}
